export const userDataFormKeys = {
  general: 'general',
  name: 'name',
  contacts: 'contacts',
  addresses: 'addresses',
  policy: 'policy',
};
